<script>
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: 'session time out',
    meta: [{ name: 'description', content: 'session time out' }],
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <Layout>
    <div id="main-session-out 123">
      <div class="content-session-out">
        <img src="/img/session.png">
        <h1>{{ $t('content.session_out.header') }}</h1>
        <p><b>{{ $t('content.session_out.line1') }}</b></p>
        <p>{{ $t('content.session_out.line2') }}</p>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
  
</style>
